import { useTranslate } from '@prenuvo/halo';

import {
  ACTIVITY_LOG_ACTION,
  ConditionDetail as ConditionDetailModel,
  FullObject,
  ReportFindingConditionDetail,
} from '@/api';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';
import { parseOrganTitle } from '@/shared/util';

import { ActionClass } from './activity-log.constant';
import { generateTitle } from './activity-log.util';
import { ActivityLogDetail } from './activity-log-detail.component';

interface ConditionDetailProps {
  action: ActionClass;
  conditionDetail: ConditionDetailModel | ReportFindingConditionDetail;
  fieldName: string;
  fullObject: FullObject | null;
}

export function ConditionDetail({
  action,
  conditionDetail,
  fieldName,
  fullObject,
}: ConditionDetailProps) {
  const translate = useTranslate();

  const isConditionTemplateDisplayNameEnabled = useIsDDFeatureFlagEnabled(
    'FCT_CONDITION_TEMPLATE_DISPLAY_NAME',
  );

  const value =
    !conditionDetail.value && action === ACTIVITY_LOG_ACTION.CREATE
      ? translate('FCT.ACTIVITY_LOGS.EMPTY_FINDING_LABEL')
      : conditionDetail.value;

  if (
    (conditionDetail.value && action === ACTIVITY_LOG_ACTION.UPDATE) ||
    action === ACTIVITY_LOG_ACTION.CREATE ||
    action === ACTIVITY_LOG_ACTION.REJECT
  ) {
    const fieldLabel = conditionDetail.displayName || parseOrganTitle(conditionDetail.name);

    return (
      <ActivityLogDetail
        action={action}
        fieldName={fieldName}
        title={generateTitle(fieldLabel, fullObject, isConditionTemplateDisplayNameEnabled)}
        value={String(value)}
      />
    );
  }

  return null;
}
